export default "__VITE_PUBLIC_ASSET__073c047b__"